export var NotificationsUrls = {
    GetNotificationsForLoggedUser: "Notification/GetNotificationsForLoggedUser",
    AddNotification: "Notification/AddNotification",
    DismissNotification: "Notification/DismissNotification",
    MarkNotificationsAsSeen: "Notification/MarkNotificationsAsSeen"
};
